import * as m from 'react-dom';module.exports = { ...m };